"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var environment_1 = require("@shared/types/environment");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
(function (module) {
    'use strict';
    module.factory('pr.personService', [
        '$q',
        '$http',
        'pr.API_ROUTES',
        'rsEnvironment',
        function ($q, $http, API_ROUTES, env) {
            /**
             * Get person info for a given personId.
             */
            function getPersonInfo(personId) {
                if (!personId) {
                    console.warn('No person Id passed');
                    return $q.when();
                }
                return $http.get(API_ROUTES.PERSON_SERVICE + personId, { cache: true }).then(function (response) {
                    return lodash_1.default.cloneDeep(response.data[personId]);
                }).catch(function (error) {
                    console.error('Could not get personId info for', personId, error);
                    return {}; // so we don't request again
                });
            }
            /**
             * Get persons for the given personIds.
             */
            function getPersons(personIds) {
                if (!lodash_1.default.isArray(personIds) || personIds.length === 0) {
                    return $q.when({});
                }
                return $http.post(API_ROUTES.PERSON_SERVICE, personIds).then(function (response) {
                    return response.data;
                }).catch(function (error) {
                    console.error('Could not get persons for ', personIds, error);
                    return {};
                });
            }
            /**
             * Get all person metadata fields of a 360 project.
             */
            function getMetadata() {
                var orgHierarchyId = getOrgHierarchyId();
                if (!orgHierarchyId) {
                    return $q.when([]);
                }
                return $http.get(API_ROUTES.PERSON_SERVICE + "metadata/" + orgHierarchyId, { cache: true })
                    .then(function (response) {
                    return lodash_1.default.cloneDeep(response.data);
                })
                    .catch(function (error) {
                    console.error('Person metadata could not be retrieved', error);
                    return [];
                });
            }
            /**
             * Get the metadata for a specific person
             * @param personId (optional)
             */
            function getPersonMetadata(personId) {
                if (!personId) {
                    console.warn('No person Id passed');
                    return $q.when({});
                }
                var orgHierarchyId = getOrgHierarchyId();
                if (!orgHierarchyId) {
                    return $q.when({});
                }
                var PERSON_METADATA_URL = API_ROUTES.PERSON_SERVICE + "metadata/" + personId + "/directory/" + orgHierarchyId;
                return $http.get(PERSON_METADATA_URL, { cache: true })
                    .then(function (response) {
                    return response.data;
                }).catch(function (error) {
                    console.error("Person metadata for " + personId + " could not be retrieved", error);
                    return {};
                });
            }
            /**
             * Get all unique values of a person metadata field.
             * @param field
             */
            function getMetadataValues(field) {
                var orgHierarchyId = getOrgHierarchyId();
                if (!orgHierarchyId) {
                    return $q.when([]);
                }
                // Field names need to be encoded so that special characters are url-safe.
                var encodedField = encodeURIComponent(field);
                return $http.get(API_ROUTES.PERSON_SERVICE + "metadata/" + orgHierarchyId + "/field/" + encodedField)
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    console.error("Person metadata " + field + " could not be retrieved", error);
                    return [];
                });
            }
            /**
             * Get personId for given userId.
             */
            function getPersonIdForUserId(userId, onlyIDs) {
                return $http.post(API_ROUTES.PERSON_SERVICE + "persons/users?onlyIDs=" + onlyIDs, [userId])
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    console.error("PersonId for userID: " + userId + " could not be retrieved", error);
                    return [];
                });
            }
            /**
             * Compute Person Metadata condition from 360 Conditional Text widget.
             */
            function computeConditionalTextPersonMetadataCondition(personId, condition, subjectPersonId) {
                var orgHierarchyId = getOrgHierarchyId();
                if (!orgHierarchyId) {
                    return $q.when(false);
                }
                return $http.post(API_ROUTES.PERSON_SERVICE + "metadata/" + orgHierarchyId + "/person/" + personId + "?subject=" + subjectPersonId, condition)
                    .then(function (response) { return response.data; })
                    .catch(function (error) {
                    console.error("Person Metadata condition could not be computed for person " + personId, error);
                    return false;
                });
            }
            /**
             * Get the 360 orgHierarchyId from the environment
             */
            function getOrgHierarchyId() {
                return env.get(environment_1.ENV_VARS.ORG_HIERARCHY_ID) || '';
            }
            return {
                getPersonInfo: getPersonInfo,
                getPersons: getPersons,
                getMetadata: getMetadata,
                getPersonMetadata: getPersonMetadata,
                getMetadataValues: getMetadataValues,
                getPersonIdForUserId: getPersonIdForUserId,
                computeConditionalTextPersonMetadataCondition: computeConditionalTextPersonMetadataCondition,
                getOrgHierarchyId: getOrgHierarchyId
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
